import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = [
    "shortLinkInput", "shortLinkBtn", "shortLinkText", "shortLinkSpin", "shortLinkContainer", "shortLinkLink", "copy", "copied", "shortLinkError"
  ]

  generateLink() {
    const linkValue = this.shortLinkInputTarget.value;

    if (!this.isValidUrl(linkValue)) {
      this.shortLinkInputTarget.classList.add("is-invalid")
      this.shortLinkErrorTarget.classList.remove("d-none")
      setTimeout(() => {
        this.shortLinkInputTarget.classList.remove("is-invalid")
        this.shortLinkErrorTarget.classList.add("d-none")
      }, 3000);
      return;
    }

    const formData = new FormData();
    formData.append("link", linkValue);
    formData.append("advertisingIabCategories", "");
    formData.append("force_create", true);
    formData.append("qrTitle", "Short Link");
    formData.append("type", "56");

    this.shortLinkBtnTarget.disabled = true;
    this.shortLinkSpinTarget.classList.remove("d-none")
    this.shortLinkTextTarget.classList.add("d-none")

    fetch("link/ajax/new", {
      method: "POST",
      body: formData,
    })
      .then(res => res.json())
      .then(data => {
        this.shortLinkLinkTarget.innerText = data.url
        this.shortLinkContainerTarget.classList.remove("d-none");
      })
      .catch(err => console.error(err))
      .finally(() => {
        this.shortLinkBtnTarget.disabled = false;
        this.shortLinkSpinTarget.classList.add("d-none")
        this.shortLinkTextTarget.classList.remove("d-none")
      });
  }

  isValidUrl(url) {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }
  clearField(){
    this.shortLinkInputTarget.value = ""
  }
  copy() {
    const content = this.shortLinkLinkTarget.innerText;
    navigator.clipboard.writeText(content).then(() => {

      this.copyTarget.classList.add("d-none")
      this.copiedTarget.classList.remove("d-none")

      setTimeout(() => {
        this.copyTarget.classList.remove("d-none")
        this.copiedTarget.classList.add("d-none")
      }, 3500);
    });
  }
}
